import React, { forwardRef, useContext, useEffect } from 'react';
import { Grid, GridItem } from '@nike/nike-design-system-components';
import { useInView } from 'react-intersection-observer';
import { bool } from 'prop-types';
import BrandMenu from '../BrandMenu';
import { AppContext } from '../../context/appContext';
import DesktopUtilityMenu from '../DesktopUtilityMenu';
import { StyledDiv, desktopBrandList, userMenuClass } from './styles';

/**
 * contains brand and utility menus
 * @param {@param} props.ref applied to grid, used to close shopping menu dropdowns more consistently
 */
const TopBar = forwardRef((_, refFromParent) => {
  const [{ isSearchOpen }, actions] = useContext(AppContext);
  const [topBarInViewRef, topBarInView] = useInView({ threshold: 0.5 });

  useEffect(() => {
    actions.setTopBarIsVisible(topBarInView);
  }, [topBarInView]);

  return (
    <StyledDiv data-testid="top-bar-container" isSearchOpen={isSearchOpen} ref={topBarInViewRef}>
      {/* adding the ref here because the parent element's ref does not work */}
      <Grid alignItems="center" className="topbar-grid" ref={refFromParent}>
        <GridItem xs={6}>
          <BrandMenu brandListWrapperClass={desktopBrandList} displayTitles={false} />
        </GridItem>
        <GridItem className={userMenuClass} xs={6}>
          <DesktopUtilityMenu />
        </GridItem>
      </Grid>
    </StyledDiv>
  );
});

TopBar.displayName = 'TopBar';

export default TopBar;

TopBar.propTypes = {
  showDesktopContent: bool,
};
